// GENERATED FILE - DO NOT MODIFY

export enum GetFoodPromotionsSortColumnDto {
    Name = "Name",
    Status = "Status",
}